<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                Zones </h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">Zones</li>
                                <!-- <li class="breadcrumb-item active" aria-current="page">
                                    {{'header.course-data.titleList.AddCourse' | translate }} </li> -->
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                
                                
                                <!-- <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                                <i class="fe fe-download me-2"></i> Import
                            </button> -->

                            </div>
                        </div>
                    </div>

                    <div class="row row-sm add-form" >
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="zoneForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <!-- *ngIf="submitButton" -->
                                        <div>
                                            <h3 class="main-content-label mb-1"><b>
                                                Zones
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                Zones
                                            </p>
                                        </div>
                                        
                                        <div class="row clearfix">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <div class="">

                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label> Exam</mat-label>
                                                            <!-- <input class="input"  matInput formControlName="Exam" placeholder="Exam" > -->
                                                            <mat-select required formControlName="ZnShId" #select23
                                                                class="colorblack">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'data'"
                                                                    [array]="ListOfExamSchedule"
                                                                    (filteredReturn)=" filteredListOfExamSchedule =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredListOfExamSchedule"
                                                                [value]="item.ShId" (click)="fetchZone(item.ShId)">
                                                                    {{item.EmName}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                                    *ngIf="zoneForm.controls['ZnShId'].touched && zoneForm.controls['ZnShId'].errors?.required">
                                                                    This Field Is Mandatory.
                                                                </mat-error>
                                                        </mat-form-field>


                                                    </div>
                                                </div>
                                            </div>
                                            <hr>
                                            <div  class="col-sm-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label>Code </mat-label>
                                                            <input required class="color"  matInput formControlName="ZnCode" placeholder="Code" >
                                                       <mat-error class="margin_tp"
                                                       *ngIf="zoneForm.controls['ZnCode'].touched && zoneForm.controls['ZnCode'].errors?.required">
                                                       This Field Is Mandatory.
                                                   </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-sm-8">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label>Name </mat-label>
                                                            <input required class="color"  matInput formControlName="ZnName" placeholder="Name" >
                                                            <mat-error class="margin_tp"
                                                            *ngIf="zoneForm.controls['ZnName'].touched && zoneForm.controls['ZnName'].errors?.required">
                                                            This Field Is Mandatory.
                                                        </mat-error> 
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                                    <div class="col-sm-12">
                                                        <button type="button"
                                                            class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            *ngIf="submitButton"   (click)="saveZones()">Submit</button>
                                                        <button type="button"
                                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            *ngIf="updateButton" (click)="updateZone()">Update</button>
                                                            <button type="button"
                                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            *ngIf="deleteButton" (click)="openConformationModalBox()">Delete</button>
                                                     
                                                        <button type="button"
                                                        class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="resetForm()" >Cancel</button>
                                                        </div>
                                           
                                        </div>
                                       
                                        
                                    </div>

                                   
                                    <div class="col-sm-12 pl-0">
                                        <!-- *ngIf="isDivShow==true" -->
                                            <div  class="table-responsive">
                                                <table  id="datatable" class="table table-striped table-bordered text-nowrap text-left">
                                                    <thead>
                                                        <tr>
                                                        
                                                            <th  class="f600" width="15%">
                                                                Code
                                                            </th>
                                                            <th width="75%" class="f600">
                                                                Name
                                                            </th>
                                                            <th  class="f600 text-center" width="10%">
                                                              Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let item of zoneList;">
                                                        
                                                            <td> {{item.ZnCode}} </td>
                                                            <td>{{item.ZnName}} </td>
                                                            <td class="text-center">  
                                                                 
                                                                <a class="btn-floating" title="Edit" (click)="editdata(item)">
                                                                    <i class="fa fa-edit"></i>
                                                                </a>
                                                                <a class="btn-floating" title="Delete" (click)="deletedata(item)">
            
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    
                                </div>

                               
                            </div>
                           
                        </form>
                    </div>
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>